import Img from '@components/img/img.view';

export default Img;
